module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ts-menu"
  }, [(!_vm.show) ? _c('ts-menu-table-item', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("\r\n    暂无数据\r\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-644dc2ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/menutable/tsMenu.vue
// module id = 836
// module chunks = 39